import React, {createContext, useContext, useEffect, useState} from 'react';
import {jwtDecode} from 'jwt-decode';
import {useNavigate} from "react-router-dom";
import {Spin} from "antd";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                const currentTime = Date.now() / 1000;

                if (decodedToken.exp < currentTime) {
                    localStorage.removeItem('token');
                    navigate('/login');
                } else {
                    setUser({
                        id: decodedToken.userId,
                        role: decodedToken.role,
                    });
                }
            } catch (error) {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
        setLoading(false);
    }, [navigate]);

    const logout = () => {
        localStorage.removeItem('token');
        setUser(null);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <AuthContext.Provider value={{ user, setUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
